import type { TextFieldProps } from './TextField';
import { TextField } from './TextField';

export type SearchFieldProps = Omit<TextFieldProps, 'type'>;

export const SearchField = (props: SearchFieldProps) => (
  <TextField type="search" {...props} />
);
